import * as React from "react";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import { Divider, Typography } from "@mui/material";
import Markdown from "react-markdown";
import { useT } from "talkr";

export default function ThankYouDialog() {
  const [open, setOpen] = React.useState(true);
    const { T, setLocale } = useT();

  const handleClose = () => {
    setOpen(false);
  };

  return (
    <>
      <Dialog
        open={open}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        fullWidth
      >
        <DialogContent>
          <Typography variant="h3" sx={{ textAlign: "center" }}>
            {T("thank_you_dialog.title")}
          </Typography>
          <Typography variant="h4" sx={{ textAlign: "center" }}>
            {T("thank_you_dialog.subtitle")}
          </Typography>
          <Typography variant="body2" sx={{ textAlign: "center" }}>
            <Markdown>
              {T("thank_you_dialog.subsubtitle")}
            </Markdown>
          </Typography>
          <Divider sx={{ my: 2 }} />
          <Typography variant="body1" sx={{ textAlign: "center", mt: 2 }}>
            <Markdown>
              {T("thank_you_dialog.description")}
            </Markdown>
          </Typography>
        </DialogContent>
        <DialogActions
          sx={{
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
            backgroundColor: "background.default",
          }}
        >
          <Button
            onClick={handleClose}
            variant="text"
            color="primary"
            sx={{
              fontSize: "0.85rem",
              padding: "4px 10px",
              minWidth: "unset",
            }}
          >
            {T("thank_you_dialog.close")}
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
}
